import { render, staticRenderFns } from "./Annoucements.vue?vue&type=template&id=31882c96&scoped=true&"
import script from "./Annoucements.vue?vue&type=script&lang=js&"
export * from "./Annoucements.vue?vue&type=script&lang=js&"
import style0 from "./Annoucements.vue?vue&type=style&index=0&id=31882c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31882c96",
  null
  
)

export default component.exports